"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var useRequest_1 = (0, tslib_1.__importDefault)(require("./useRequest"));
var useAuth_1 = require("../auth/useAuth");
var useGridAPI = function (apiName) {
    var request = (0, useRequest_1.default)(apiName).request;
    var getCognitoUserSessionToken = (0, useAuth_1.useAuth)().getCognitoUserSessionToken;
    var gridRequest = (0, react_1.useCallback)(function (_a) {
        var url = _a.url, _b = _a.method, method = _b === void 0 ? 'GET' : _b, _c = _a.headers, headers = _c === void 0 ? {} : _c, params = _a.params, data = _a.data, cancelToken = _a.cancelToken;
        return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var res, _d, _e;
            var _f, _g;
            return (0, tslib_1.__generator)(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _d = request;
                        _f = {
                            url: url,
                            method: method
                        };
                        _e = [(0, tslib_1.__assign)({}, headers)];
                        _g = {};
                        return [4 /*yield*/, getCognitoUserSessionToken()];
                    case 1:
                        res = _d.apply(void 0, [(_f.headers = tslib_1.__assign.apply(void 0, _e.concat([(_g.Authorization = _h.sent(), _g)])),
                                _f.params = params,
                                _f.data = data,
                                _f.cancelToken = cancelToken,
                                _f)]);
                        return [2 /*return*/, res];
                }
            });
        });
    }, [request, getCognitoUserSessionToken]);
    return { request: gridRequest };
};
exports.default = useGridAPI;
